import Service from "../../service/index";


const getDefaultState = () => {
    return {
        access_token: null,
        token_type: null,
        users: null,
    };
};
const Auth = {
    namespaced: true,
    state: {
        test : "",
        user: [],
        user_login: null,
        form: {
            first_name: "",
            last_name : "",
            sid : "",
            phone_number: "",
            email: "",
        },
        login_form:{
            sid: "",
            phone_number:"",

        },
        access_token: null,
        token_type: null,
        registerToken : null,
        username : "",
        users: null,
        first_name: "",
        last_name: "",
    },
    mutations: {
        SET_USER: (state, user) => {
            state.user = user.hospname;
        },
        SET_USER_LOGIN: (state, user) => {
            state.user_login = user;
        },
        SET_TOKEN_REGISTER : (state, token) => {
            state.registerToken = token;
        },
        SET_TOKEN(state, res) {
            state.access_token = res.access_token;
            state.token_type = res.token_type;
            state.username = res.user.first_name+' '+res.user.last_name;
            state.users = res.user;
        },
        CLEAR_FORM_DATA: state => {
            state.form = {
                first_name: "",
                last_name : "",
                sid : "",
                phone_number: "",
                email: "",
            };
        },
        RESET: state => {
            Object.assign(state, getDefaultState());
        },
    },
    actions: {
        login({ commit }, data) {
            return Service.Auth.login(data).then(response =>{
                // console.log(response.user )
                commit('SET_TOKEN', response );
                console.log("This is Login",response)

            });

        },
        request({ commit }, data) {
            return Service.Auth.request(data).then(response => {
                console.log('regis',response)
                // commit("SET_TOKEN_REGISTER", response.success.token);
                // commit("SET_USER", response);
                return data;
            });
        },
        logout({ commit }) {
            commit("RESET",'');
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        setUser({commit}) {
            return Service.Auth.getUserAll().then(res => {
                commit("SET_USER", res);
            });
        },
        getToken({ commit }, data) {
            return Service.Auth.getToken(data).then(data => {
                commit("SET_TOKEN", data.success.token);
            }).catch(err => Promise.reject(err));
        },
        getTest({commit}, data){
            commit("TEST",data);
        }
    }
};

export default Auth;
